package com.wintermar.inspection

import androidx.compose.runtime.Composable
import androidx.compose.ui.unit.Dp
import com.wintermar.inspection.navigation.Route

@Composable
actual fun TopMenu(
    isOpenMenu: Boolean,
    currentRoute: Route?,
    onToggle: () -> Unit,
    onHeightChanged: (Dp) -> Unit
) {
}
